<template>
    <div class="page light">

        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back()" class="link back " v-bind:class="{'hidden': voltar}">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title" style="">Gerenciar agendas</div>
                <div class="right">
                    <a  class="link hidden">
                        <i class="las la-shopping-cart"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="page-content pt-60 bottom-sp60" v-bind:class="{'disabled': $root.user.confirmacao == 0}">
            
            <div class="container hidden-xs hidden-md">
                <h2>Gerenciar agendas</h2>
            </div>

            <div class="block block-strong inset" style="background: #f7f7f7; margin-left: 30px; margin-right: 30px; margin-top: 10px; margin-bottom: 0px; padding-bottom: 1px !important; padding-top: 10px !important;">
                <p style="line-height: 140%;">
                    <!-- Olá, como vai?  <i class="las la-smile-beam"></i><br><br> -->
                    <i class="las la-calendar" style="color: var(--f7-theme-color)"></i> Gerencie abaixo os serviços disponibilizados e as suas agendas para cada modalidade (telemedicina, presencial, domiciliar).
                    <div style="display: block; height: 5px; width: 100%;"></div>
                    <i class="las la-plus-square" style="color: var(--f7-theme-color)"></i> Você pode adicionar novos locais de atendimento presencial em <b>adicionar nova agenda</b>.
                    <!-- <br><br> -->
                    <!-- Dentro de cada agenda você consegue definir os serviços, dias e horários disponíveis para agendamentos. -->
                </p>
            </div>


<!--             <div class="empty" v-if="data.itens.length == 0 && data.loaded">
                <center>
                    <img src="static/images/empty.png" style="width: 80%">
                    <p class="mt-0 pt-0">
                        <i class="las la-times"></i>
                        Nenhum resultado encontrado.
                    </p>
                </center>
            </div> -->

            <div class="container notification-list">
                <button v-on:click="$root.go('CadastrarAgendas', JSON.stringify({'t': Math.random()}))" type="button" class="button mt-5" style="padding-right: 34px;
    justify-content: flex-end;">
                    <i class="las la-plus"></i>
                    Adicionar nova agenda
                </button>
                <ul>

                    <li v-for="(item, index) in data.itens" :key="item.cod" style="position: relative;">
                        <h6 class="item-title" style="font-weight: 600; padding-right: 30px;" v-on:click="gerenciar(item.cod)">
                            <i class="las la-circle"></i> {{item.nome}}
                            <i class="las la-edit" style="font-size: 20px; position: absolute; right: 30px; color: #bbb;"></i>
                            <br>
                            <small style="font-weight: 400; color: #666;">
                                <i class="las la-clock"></i> Última modificação: {{item.atualizacao | formatDate}}
                            </small>

                        </h6>
                        <div class="item-text" style="font-size: 12px; padding-top: 10px; text-align: right;">
                            <div class="row" style="justify-content: flex-end;">
                                <div class="col-100 large-50">
                                    <button v-on:click="$root.go('ConfigurarAgendas', JSON.stringify({'c': item.cod, 't': Math.random()}))" type="button" class="button button-fill " style=" font-size: 14px;  ">
                                        <i class="las la-clock"></i> Configurar horários
                                    </button>   
                                </div>   
                                <div class="col-100 large-50">
                                    <button v-on:click="$root.go('Servicos', JSON.stringify({'c': item.cod, 't': Math.random()}))" type="button" class="button button-fill color-green " style=" font-size: 14px;  ">
                                        <i class="las la-briefcase-medical"></i> Configurar serviços
                                    </button>   
                                </div>   
                            </div>   

                        </div>
                    </li>

                </ul>
            </div>

        </div>
        
        <Toolbar></Toolbar>
    </div>
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'Agendas',
    components: {
        'Toolbar': Toolbar,
        'Top':  Top
    },          
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },      
    data () {
        var self                    = this;
        return {
            "voltar":               false,
            "data":                 {
                "pages":            [],
                "itens":            []
            },
            "tab":                  "todos",
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "page":             1,
                "pesquisa":         "",
                "tipo":             "especialidade"
            }              
        }
    },
    methods: {   
        gerenciar: function(cod) {
            var self = this;
            console.log("gerenciar()", cod);
            window.___app.dialog.create({
                title: 'Gerenciar agenda',
                text: '',
                buttons: [
                    {
                        text: 'Editar',
                        onClick: function() {
                            self.$root.go("EditarAgendas", JSON.stringify({"c": cod}));
                        }
                    },
                    {
                        text: 'Apagar',
                        onClick: function() {
                            self.del(cod);
                        }
                    },                                                                      
                    {
                        text: '<span style="color: red; font-weight: 200">Voltar<span>',
                    },                                                            
                ],
                verticalButtons: true,
            }).open();            
        },         
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/agendas.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.$forceUpdate();
                    loading.hide();
                    resolve(response.data.result);
                    self.$root.scrollTop();
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/agendas.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }        
    },
    beforeMount: function(e){
    },    
    activated: function() {
        var self = this;

        self.get();
    },
    mounted: function() {
        var self            = this;
        // self.$root.cache.categorias.  
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
   
    .tag-list {
        margin-bottom: 0px !important;
        margin-top: 0px;
    }

    .item-title {
        margin-bottom: 0px !important;
        line-height: 130%;
        font-weight: 500;
        font-size: 16px;
    }
    .chip-label {
        font-weight: bold;
        font-size: 12px !important;
    }
    .chip {
        line-height: 18px !important;
        height: auto !important;
        min-height: 18px !important;
        /*padding-bottom: 0px;*/
        /*padding-top: 0px;*/
        margin-top: -4px;
        margin-left: -2px;
        margin-bottom: 5px;
    }
    .dz-media {
        margin-bottom: 5px !important;
    }
    .tabbar.tab-style-2 .tab-link:after {
        display: none !important;
    }

    .banner {
        background: var(--f7-theme-color);
        padding: 20px;
        margin-bottom: 30px;
    }

    .banner h4 {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }

    .banner p {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }    

    .img-perfil {
        width: 50px;
        height: 50px;
        background-size: cover;
        background-position: center;
        border: 1px solid #ddd;
        border-radius: 6px;
        display: inline-block;
    }    

    .col-50-grid {
      margin: 0;
      display: grid;
      grid-template-rows: 1fr auto;
      margin-bottom: 10px;
      break-inside: avoid;    
    }

    .row-grid {
      column-count: 2;
      column-gap: 20px;
    }
  
    .item-bx.item-grid {
        margin-bottom: 15px;
    }         

    .categories-bx.active {
        background: #f8b832 !important;
        color: #222 !important;
    }

    .cart-list-area {
        padding-left: 0;
        padding-right: 0;
    }

    .cart-list {
        overflow: hidden;
        margin: 0;
    }

    .cart-item {
        background-color: #fff;
        overflow: unset;
        margin: 6px 0;
        border-bottom: 1px solid #ddd;
        padding-bottom: 0px;        
    }        
   
    .cart-item .item-inner {
        background-color: #fff;
        padding: 12px 30px;
    }   

    .cart-item .item-media {
        min-width: 95px !important;
        width: 95px;
        position: relative;
        padding: 0;
        border-radius: 16px;
        overflow: hidden;
        margin-right: 20px;
        height: 115px;
        align-items: flex-start;
        height: 105px;
    }

    .cart-item .item-media img {
        width: 100%;
    }

    .cart-item .item-media .item-price {
        background-color: var(--f7-theme-color);
        color: #fff;
        position: absolute;
        bottom: 0;
        margin: 0;
        width: 100%;
        left: 0;
        text-align: center;
        font-weight: 500;
        font-size: 16px;
        padding: 5px;
        border-radius: 16px;
        box-sizing: border-box;
    }

    .cart-item .item-info {
        width: 100%;
        justify-content: space-between;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 5px 0;
        box-sizing: border-box;
    }

    .cart-item .item-foot {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .cart-item .item-foot .item-total {
        margin: 0;
        font-weight: 500;
        font-size: 16px;
    }                        

    .cart-item .item-content {
        padding-left: 0;
        transition: all 0.5s;
    }

    .cart-item .item-head .category {
        margin: 0;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
    }

    .cart-item .item-title a {
        color: #000;
        word-break: break-word;
        white-space: break-spaces;
        text-overflow: ellipsis;
        display: block;
        line-height: 130%;
    }

    .cart-item .item-title {
        font-weight: 500;
        margin: 0 0 10px;
    }        

    .cart-item .item-media div {
        width: 100%;
        height: 100%;
        background-size: cover !important;
        background-position: center;
        background: #efefef;
        border-radius: 6px;
    }

    .button-round {
        border-radius: 20px !important;
    }

    .badge-large {
        padding: 15px;
    }

    .badge-outline:not(.color-green) {
        background: transparent !important;
        border: 2px solid #064972 !important;
        color: #064972;
    }

    .badge.color-secondary {
        border: 2px solid #064972 !important;
    }

    .badge.color-primary {
        border: 2px solid #0f8cd5 !important;
    }    

    .badge.color-green:not(.badge-outline) {
        border: 2px solid #4cd964 !important;
    }

    .badge-outline.color-green {
        background: transparent !important;
        border: 2px solid #4cd964 !important;
        color: #4cd964;
    }    


    .button-fill.color-grey {
        background: #ddd !important;
        color: #666 !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Agendas.vue